import { render, staticRenderFns } from "./OnboardingFab.vue?vue&type=template&id=03002c4b&scoped=true&lang=pug"
import script from "./OnboardingFab.vue?vue&type=script&lang=js"
export * from "./OnboardingFab.vue?vue&type=script&lang=js"
import style0 from "./OnboardingFab.vue?vue&type=style&index=0&id=03002c4b&prod&lang=scss&scoped=true"
import style1 from "./OnboardingFab.vue?vue&type=style&index=1&id=03002c4b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03002c4b",
  null
  
)

export default component.exports